import SellerInboundCurationStatusBadge from 'domains/seller-inbound/atoms/curation-status-badge'
import PropTypes from 'prop-types'
import React from 'react'
import { Card, CardFooter, CardHeader, Table } from 'reactstrap'
import TimeUtil from 'utils/time-util'


const proptypes = {
  inbound: PropTypes.shape({
    curation_status : PropTypes.string,
    curation        : PropTypes.shape({
      curated_by: PropTypes.shape({
        name: PropTypes.string
      }),
      code           : PropTypes.string,
      curated_date   : PropTypes.string,
      received_total : PropTypes.number,
      accepted_total : PropTypes.number,
      rejected_total : PropTypes.number,
      lost_total     : PropTypes.number
    })
  }),
  footerComponent: PropTypes.element
}

/**
 * Provide the summary of Seller Inbound Curation
 * @param {object} inbound - Seller Inbound
 * @param {element} footerComponent - Handler to confirm curation process
 */
const SellerInboundCurationCard = ({
  inbound,
  footerComponent
}) => (
  <>
    <Card>
      <CardHeader>
        <span className='small text-uppercase text-light font-weight-bolder'>
          { 'Curation' }
        </span>
        <h2>
          <span className='mr-3'>{ inbound?.curation?.code }</span>
          <small>
            <SellerInboundCurationStatusBadge
              curation_status={ inbound?.curation_status }
            />
          </small>
        </h2>
      </CardHeader>

      <Table hover className='mb-0'>
        <tbody>
          <tr>
            <th scope='row'>Curated By</th>
            <td>{ inbound?.curation?.curated_by?.name }</td>
          </tr>
          <tr>
            <th scope='row'>Curated Date</th>
            <td>{ TimeUtil.format(inbound?.curation?.curated_date) }</td>
          </tr>
          <tr>
            <th scope='row'>Received Total</th>
            <td>{ inbound?.curation?.received_total }</td>
          </tr>
          <tr className='text-success'>
            <th scope='row'>Accepted Total</th>
            <td>{ inbound?.curation?.accepted_total }</td>
          </tr>
          <tr className='text-danger'>
            <th scope='row'>Rejected Total</th>
            <td>{ inbound?.curation?.rejected_total }</td>
          </tr>
          <tr className='text-warning'>
            <th scope='row'>Lost Total</th>
            <td>{ inbound?.curation?.lost_total }</td>
          </tr>
        </tbody>
      </Table>

      <CardFooter className=''>
        { footerComponent }
      </CardFooter>

    </Card>
  </>
)

SellerInboundCurationCard.propTypes = proptypes

export default SellerInboundCurationCard